import { useQueryParams } from '@shared/utils/hooks/useQueryParams';

const supportedScenarios = ['app', 'default', 'guest-list', 'invitation', 'registry', 'save-the-date', 'wedding-website'] as const;

type Scenario = (typeof supportedScenarios)[number];

// marcom /honeymoon-registry/ sends its own scenario so signed-in couples can be routed to the honeymoon
// fund (see useAutoRedirectToScenario); new couples get the same create-event copy as `registry`.
const scenarioAliases: Readonly<Record<string, Scenario>> = {
  'honeymoon-registry': 'registry',
};

export const useScenario = (): Scenario => {
  const queryParams = useQueryParams();
  const rawScenario = typeof queryParams.scenario === 'string' ? queryParams.scenario : undefined;
  const scenario = (rawScenario && scenarioAliases[rawScenario]) || rawScenario;

  return supportedScenarios.includes(scenario as Scenario) ? (scenario as Scenario) : 'default';
};
